import React from 'react'
import { Navigate, Outlet } from "react-router-dom";

const   PrivateRoute = ({ children }) => {

    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
    return isLoggedIn ? children : <Navigate to="/" />;
 
}

export default PrivateRoute;